!(function r(c, u, a) {
    function s(e, t) {
        if (!u[e]) {
            if (!c[e]) {
                var n = "function" == typeof require && require;
                if (!t && n) return n(e, !0);
                if (d) return d(e, !0);
                var o = new Error("Cannot find module '" + e + "'");
                throw ((o.code = "MODULE_NOT_FOUND"), o);
            }
            var i = (u[e] = { exports: {} });
            c[e][0].call(
                i.exports,
                function (t) {
                    return s(c[e][1][t] || t);
                },
                i,
                i.exports,
                r,
                c,
                u,
                a
            );
        }
        return u[e].exports;
    }
    for (var d = "function" == typeof require && require, t = 0; t < a.length; t++) s(a[t]);
    return s;
})(
    {
        1: [
            function (t, e, n) {
                "use strict";
                var o,
                    i = t("./modules/Cart/cart-index.js"),
                    r = (o = i) && o.__esModule ? o : { default: o };
                document.addEventListener("DOMContentLoaded", r.default.init);
            },
            { "./modules/Cart/cart-index.js": 5 },
        ],
        2: [
            function (t, e, n) {
                "use strict";
                Object.defineProperty(n, "__esModule", { value: !0 }), (n.default = { cart: {} });
            },
            {},
        ],
        3: [
            function (t, e, n) {
                "use strict";
                Object.defineProperty(n, "__esModule", { value: !0 });
                var o = {
                    init: function () {
                        o.cookiesEnabled();
                    },
                    cookiesEnabled: function () {
                        var t = navigator.cookieEnabled;
                        return t || ((document.cookie = "testcookie"), (t = -1 !== document.cookie.indexOf("testcookie"))), t;
                    },
                };
                n.default = { init: o.init };
            },
            {},
        ],
        4: [
            function (t, e, n) {
                "use strict";
                Object.defineProperty(n, "__esModule", { value: !0 });
                var o,
                    i = t("./__cache-selectors");
                ((o = i) && o.__esModule ? o : { default: o }).default.cart;
                var r = {
                    init: function () {
                        r.cartButtons();
                    },
                    cartButtons: function () {
                        $(".x-cart__btn-see-more").on("click", function (t) {
                            localStorage.removeItem("donation"), localStorage.removeItem("institution_address");
                        }),
                            $(".x-cart__btn-checkout").on("click", function (t) {
         
                                var e = localStorage.getItem("donation"),
                                    n = localStorage.getItem("institution_address");
                                e && CartJS.setAttribute("institution_address", n);
          					 
                            });
                    },
                };
                n.default = { init: r.init };
            },
            { "./__cache-selectors": 2 },
        ],
        5: [
            function (t, e, n) {
                "use strict";
                Object.defineProperty(n, "__esModule", { value: !0 });
                var o = r(t("./_cart__cookie.js")),
                    i = r(t("./_cart__main.js"));
                function r(t) {
                    return t && t.__esModule ? t : { default: t };
                }
                n.default = {
                    init: function () {
                        o.default.init(), i.default.init();
                    },
                };
            },
            { "./_cart__cookie.js": 3, "./_cart__main.js": 4 },
        ],
    },
    {},
    [1]
);
